/* eslint-disable no-undef */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/require-default-props */
import React from 'react';
import ItemListSideMenu from '../itemListSideMenu';

interface Props {
    icon: JSX.Element;
    action: Function;
    name: string;
    path: string;
}

const CollapseSideMenu: React.FC<Props> = ({
  icon, action, name, path,
}) => (
  <ItemListSideMenu
    name={name}
    icon={icon}
    route={path}
    onPress={() => (action ? action() : null)}
  />
);
export default CollapseSideMenu;
